module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('Slider'), _vm._v(" "), _c('NaviBar'), _vm._v(" "), _c('ContentWrap', {
    staticClass: "sl-ml sl-full"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-efbe2fb2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Dash.vue
// module id = 1132
// module chunks = 1